import { useState, useCallback } from 'react';
import useAuth from 'data/hooks/useAuth';
import { useMediaQuery } from '@material-ui/core';
import { from } from 'styles/media';
import useSocket from 'data/hooks/useSocket';
import useMe from 'data/hooks/useMe';
import useModalNotifications from 'data/hooks/useModalNotifications';

const useConnect = () => {
  // const { modalNotifications, addModalNotification, closeModalNotification } =
  const { modalNotifications, closeModalNotification } =
    useModalNotifications();

  // useSocket(addModalNotification);
  useSocket();

  const { logout } = useAuth();
  const { me, isLoading } = useMe();
  const [openMenu, setOpenMenu] = useState(false);
  const [openReferal, setOpenReferal] = useState(false);
  const isTablet = !useMediaQuery(from.tablet);

  const handleOpenMenu = useCallback(() => {
    setOpenMenu(true);
  }, [setOpenMenu]);

  const handleCloseMenu = useCallback(() => {
    setOpenMenu(false);
  }, [setOpenMenu]);

  const handleOpenReferal = useCallback(() => {
    setOpenReferal(true);
  }, [setOpenReferal]);

  const handleCloseReferal = useCallback(() => {
    setOpenReferal(false);
  }, [setOpenReferal]);

  return {
    openReferal,
    handleOpenReferal,
    handleCloseReferal,
    handleOpenMenu,
    handleCloseMenu,
    openMenu,
    isTablet,
    logout,
    me,
    isLoading,
    modalNotifications,
    closeModalNotification,
  };
};

export default useConnect;
